import axios from 'axios'
import { Message, Notification } from 'element-ui'
import { getToken } from '@/utils/auth'

const sessionCache = {
  set(key, value) {
    if (sessionStorage && key != null && value != null) {
      sessionStorage.setItem(key, value)
    }
  },
  get(key) {
    if (sessionStorage) {
      return key == null ? null : sessionStorage.getItem(key)
    }
    return null
  },
  setJSON(key, value) {
    if (value != null) {
      this.set(key, JSON.stringify(value))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
    return null
  },
  remove(key) {
    sessionStorage.removeItem(key)
  }
}

const localCache = {
  set(key, value) {
    if (localStorage && key != null && value != null) {
      localStorage.setItem(key, value)
    }
  },
  get(key) {
    if (localStorage) {
      return key == null ? null : localStorage.getItem(key)
    }
    return null
  },
  setJSON(key, value) {
    if (value != null) {
      this.set(key, JSON.stringify(value))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
    return null
  },
  remove(key) {
    localStorage.removeItem(key)
  }
}

const cache = {
  session: sessionCache,
  local: localCache
}

function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    var part = encodeURIComponent(propName) + '='
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            let params2 = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params2) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

let tokenFail = null

const service = axios.create({
  baseURL: '/kola',
  timeout: 30000
})

// request interceptor
service.interceptors.request.use(
  config => {
    const isToken = (config.headers || {}).isToken === false
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

    if (getToken() && !isToken) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }

    // get request params serialization
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }

    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
      const requestObj = {
        url: config.url,
        data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      } else {
        const sessionUrl = sessionObj.url
        const sessionData = sessionObj.data
        const sessionTime = sessionObj.time
        const interval = 1000
        if (sessionData === requestObj.data && requestObj.time - sessionTime < interval && sessionUrl === requestObj.url) {
          const message = '数据正在处理，请勿重复提交'
          console.warn(`[${sessionUrl}]: ` + message)
          return Promise.reject(new Error(message))
        }
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.respCode === 111) {
      if (!tokenFail) {
        tokenFail = setTimeout(() => {
          Message.error(response.data.message)
          tokenFail = null
          new Promise.reject(new Error('token已失效'))
        }, 200)
      }
    }
    return response.data
  },
  error => {
    if (error.response) {
      const status = error.response.status
      if (status === '403') {
        Notification({
          type: 'error',
          title: '错误',
          message: '暂无权限',
          duration: 2000
        })
      }
      if (status === '401') {
        Notification({
          type: 'warning',
          title: '提示',
          message: 'token已过期请重新登录',
          duration: 2000
        })
        // removeToken()
        location.href = '/'
      }
      if (status === '500') {
        Notification({
          type: 'error',
          title: '错误',
          message: '服务器异常，请联系管理员',
          duration: 2000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
